import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  title: {
    textAlign: 'center',
    mb: '8px'
  } satisfies SxProps<Theme>,
  subtitle: {
    textAlign: 'center',
    mb: '32px'
  } satisfies SxProps<Theme>,
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    mb: '24px'
  } satisfies SxProps<Theme>,
  sectionHeading: {
    mb: '-8px'
  } satisfies SxProps<Theme>,
  requirements: {
    listStyle: 'none',
    m: 0,
    p: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  } satisfies SxProps<Theme>,
  requirement: (met: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: met ? 'var(--green-700)' : 'var(--grey-500)'
  } satisfies SxProps<Theme>),
  submit: {
    minHeight: '44px',
    borderRadius: '4px'
  } satisfies SxProps<Theme>,
  alert: {
    mb: '20px'
  } satisfies SxProps<Theme>,
  backLink: {
    display: 'block',
    mt: '20px',
    textAlign: 'center'
  } satisfies SxProps<Theme>
}
